// extracted by mini-css-extract-plugin
export var cardIcon = "_74-5";
export var cardIconUnframed = "_74-9";
export var checkboxCard = "_74-0";
export var checkboxCardSelected = "_74-4";
export var disabled = "_74-2";
export var interactive = "_74-1";
export var outerBorder = "_74-3";
export var spacerMedium = "_74-8";
export var spacerSmall = "_74-7";
export var spacerXsmall = "_74-6";